module.exports = __webpack_public_path__ + "static/chill_guy-e7aed16b669ae9466e6aa59a63932c75.png";